import { useState, useEffect, useCallback } from "react";
import {
  collection,
  setDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  getCountFromServer,
  getDocs,
} from "firebase/firestore";
import { db } from "config/firebase";

const useLikes = (path) => {
  const [likes, setLikes] = useState([]);
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);

  useEffect(() => {
    if (!path) return;

    const likesRef = collection(db, ...path.split("/"), "likes");

    // Use getDocs instead of onSnapshot for initial load in lists
    getDocs(likesRef).then((snapshot) => {
      const likesData = snapshot.docs.map((doc) => doc.id);
      setLikes(likesData);
      setLikeCount(snapshot.size);
    });
  }, [path]);

  const toggleLike = useCallback(
    async (userId) => {
      if (!path || !userId) return;

      const likeDocRef = doc(db, ...path.split("/"), "likes", userId);

      try {
        if (likes.includes(userId)) {
          setLikes((prev) => prev.filter((id) => id !== userId));
          setLikeCount((prev) => prev - 1);
          await deleteDoc(likeDocRef);
        } else {
          setLikes((prev) => [...prev, userId]);
          setLikeCount((prev) => prev + 1);
          await setDoc(likeDocRef, {
            userId,
            timestamp: new Date(),
          });
        }
      } catch (error) {
        console.error("Error toggling like:", error);
        // Rollback on error if necessary, but for now just log
      }
    },
    [path, likes],
  );

  useEffect(() => {
    // We'll pass the current user ID to check if liked, but we can also do it locally
  }, [likes]);

  return {
    likes,
    likeCount,
    toggleLike,
    checkIfLiked: (userId) => likes.includes(userId),
  };
};

export default useLikes;
